module.exports = __webpack_public_path__ + "img/cs1.84bfd54e.png";